<div class="filter-container">
  @if (ds) {
    <mat-form-field class="search-input">
      <input
        id="filterInputField"
        matInput
        placeholder="Filter"
        [(ngModel)]="filterValue"
        (keyup)="onKeyUp($event)"
        data-id="filterInputField" />
    </mat-form-field>
  }

  <mat-slide-toggle [(ngModel)]="locksOnly" (change)="onToggleSwitch($event)" class="locks-toggle"
    >Locked by me
  </mat-slide-toggle>
  <mat-slide-toggle [(ngModel)]="selectedCohortOnly" (change)="selectedCohortToggleSwitch($event)" class="locks-toggle"
    >Current cohort
  </mat-slide-toggle>
</div>
@if (elasticFilter) {
  <div class="quick-filter-container">
    <div>
      @for (filterDef of elasticFilters; track filterDef) {
        <span
          class="quick-filter"
          [ngStyle]="filterDef.ngStyle"
          (click)="quickFilterClicked(filterDef)"
          matTooltip="{{ filterDef.description || filterDef.queryString }}">
          {{ filterDef.label }}
        </span>
      }
    </div>
  </div>
}
